<kodit-dropdown
(optionChanged)="handleOnItemChange($event)"
[formCtrlId]="formCtrlId"
[options]="items"
ctrlTooltip="Izaberite tip povezanog dokumenta"
ctrlTooltipPosition="top"
[formCtrl]="formCtrl"
[ctrlDisabled]="shouldDisable"
>
</kodit-dropdown>